/**=========================================================
 * Module: app-qaiprocess.js
 * QAi Process 
 =========================================================*/

 App.directive('appQaiprocess', function(){
    'use strict';
  
    return {
        templateUrl: '/app/views/partials/qaiprocess.html',
        restrict: 'E',
        replace: true,
        controller: 'QaiController',
        scope: { 
            sectionTitle: '@sectionTitle',
            parentEntity: '=parentEntity',
            idSuffix: '@idSuffix',
            formName: '@formName' 
          }
    };
  
  });